import { DocumentData, FirestoreDataConverter } from 'firebase/firestore'

export interface SyncMetadata {
  qboId?: string
  lastSynced?: number
  lastSyncStatus?: 'success' | 'error' | 'conflict'
  lastSyncError?: string
  conflictData?: any
  syncToken?: string
}

export class Customer {
  id?: string
  accountId?: string
  hubspotId?: string
  qboId?: string
  name: string
  email: string
  phone: string
  address: string
  billing: string
  isCompany: boolean
  companyId?: string
  syncMeta?: SyncMetadata
  createdAt: Date
  updatedAt: Date

  constructor () {
    this.name = ''
    this.email = ''
    this.phone = ''
    this.address = ''
    this.billing = ''
    this.isCompany = false
    this.createdAt = new Date()
    this.updatedAt = new Date()
  }
}

export const customerConvertor: FirestoreDataConverter<Customer, DocumentData> = {
  toFirestore(customer: Customer) {
    customer.createdAt = customer.createdAt ? new Date(customer.createdAt) : new Date()
    customer.updatedAt = new Date()

    return Object.assign({}, customer)
  },

  fromFirestore(snapshot, options) {
    const data = snapshot.data(options)
    data.createdAt = (typeof data.createdAt === 'object') ? data.createdAt.toDate() : data.createdAt
    data.updatedAt = (typeof data.updatedAt === 'object') ? data.updatedAt.toDate() : data.updatedAt
    
    return Object.assign(new Customer(), data)
  }
}
